import {
  createTheme,
  type MantineColorsTuple,
  type MantineThemeOverride,
} from '@mantine/core';

// Open Sans wird im Build durch @fontsource/open-sans gebundelt
// (Import in main.tsx).

// LAG-Türkis (laghessen.de Akzent #37B6BD) als Mantine-Farb-Tuple.
// Hand-tuned shades, damit Mantine 0..9 nutzen kann.
const lag: MantineColorsTuple = [
  '#e8f7f8',
  '#cfeff1',
  '#9ddfe3',
  '#67ced5',
  '#3fc0c8',
  '#37B6BD', // 5 — Default-Primary
  '#2da3a9',
  '#1f8085',
  '#0f5d61',
  '#073b3e',
];

// LAG-Slide-Akzentfarben (für Recharts/Badges).
export const LAG_CHART_PALETTE = [
  '#37B6BD', // Türkis
  '#072c5e', // Dunkelblau
  '#c0830b', // Senf
  '#a31366', // Bordeaux
  '#54770f', // Oliv
  '#9d1111', // Rot
];

export const theme: MantineThemeOverride = createTheme({
  primaryColor: 'lag',
  primaryShade: { light: 5, dark: 4 },
  defaultRadius: 'sm',
  fontFamily: '"Open Sans", Arial, Helvetica, sans-serif',
  headings: {
    fontFamily: '"Open Sans", Arial, Helvetica, sans-serif',
    fontWeight: '600',
    textWrap: 'balance',
  },
  colors: {
    lag,
  },
  components: {
    Button: {
      defaultProps: {
        size: 'sm',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'sm',
      },
    },
    Card: {
      defaultProps: {
        radius: 'sm',
      },
    },
  },
  other: {
    chartPalette: LAG_CHART_PALETTE,
    brand: {
      darkBlue: '#072c5e',
      bodyText: '#747474',
      headingText: '#333333',
      divider: '#e8e8e8',
      surfaceMuted: '#f6f6f6',
    },
  },
});
